import {
    FETCH_CUSTOMER_ORDER,
    FETCH_CUSTOMER_ORDER_SUCCESS,
} from '../types/customerType'

const initialState = {
    customerOrder: []
}

const customers = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CUSTOMER_ORDER: return {
            ...state,
            customerOrder: state.customerOrder
        }
        case FETCH_CUSTOMER_ORDER_SUCCESS: return {
            ...state,
            customerOrder: action.payload
        }
        default: return state
    }
}

export default customers